import type { FC } from 'react';
import { useMemo } from 'react';

import type { BarChartDataItem, BarChartFormatter } from '../../../../../components/BarChart';
import { BarChart } from '../../../../../components/BarChart';
import type { Opportunity } from '../../../../../domain/opportunity';
import { formatPercentage, formatWithSuffix } from '../../../../../services/numberFormat';
import { secondsToHMS } from '../../../../../services/timeFormat';

export const OpportunityGraph: FC<{ insight: Opportunity }> = ({ insight }) => {
  const graphData: BarChartDataItem[] = useMemo(() => {
    let data: BarChartDataItem[] =
      insight.competitors
        ?.filter((c) => !!c.value)
        .map((c) => ({
          name: c.domain,
          favicon: c.favicon,
          value: c.value,
          isHighlighted: false,
        })) ?? [];

    data = data.concat({
      name: insight.prospect.domain,
      favicon: insight.prospect.favicon,
      value: insight.prospect.value,
      isHighlighted: true,
    });

    return data.sort((a, b) => b.value - a.value);
  }, [insight]);

  const opportunityFormatter: BarChartFormatter = (value: number) => {
    if (insight.benchmark.units === '%') {
      return formatPercentage(value, 2);
    }
    if (insight.benchmark.units === 's') {
      return secondsToHMS(value);
    }
    return formatWithSuffix(value, 2);
  };

  return <BarChart chartData={graphData} format={opportunityFormatter} />;
};
